import Axios from 'axios';

/**
 *
 * @param { string } searchTerm
 * @returns [aanbodIndex]
 */
async function getBySearchTerm(searchTerm, cancelToken) {
  const response = await Axios.get(
    `${process.env.VUE_APP_API_ENDPOINT}/api/v2/AanbodDefinitieIndex?aanbodNaam=${searchTerm}&take=5`,
    {
      cancelToken: cancelToken,
      ignoreGlobalErrorHandler: true
    }
  );

  return response.data;
}
export default {
  getBySearchTerm
};
